import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { METERING, IMAGES } from "@/data/content";
import { SectionHeader, CTAButton } from "@/components/ui-bits";
import { Reveal, staggerParent, staggerChild } from "@/components/motion-primitives";

export const Metering = () => (
  <section id="metering" className="relative py-24 md:py-32 bg-brand-dark grain overflow-hidden">
    <div className="absolute inset-0 opacity-[0.06]">
      <img src={IMAGES.metersAlt} alt="" aria-hidden="true" className="w-full h-full object-cover" />
    </div>
    <div className="container mx-auto px-4 md:px-8 relative">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <SectionHeader
            dark
            overline="Metering Services"
            title="Electricity & water metering solutions"
            subtitle="Give property owners, landlords, body corporates, managing agents and businesses greater visibility over electricity and water consumption."
          />
        </div>
        <div className="lg:col-span-5 lg:flex lg:justify-end">
          <Reveal delay={0.1}>
            <CTAButton href="#quote" variant="secondary" size="lg" icon={ArrowRight} testId="metering-cta">Request a Metering Assessment</CTAButton>
          </Reveal>
        </div>
      </div>

      <motion.div
        variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
        className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5"
      >
        {METERING.map((m, i) => {
          const Icon = m.icon;
          return (
            <motion.div
              key={i} variants={staggerChild} data-testid={`metering-card-${i}`}
              className="group rounded-2xl border border-white/10 bg-white/[0.04] p-7 hover:bg-white/[0.07] hover:border-secondary/40 transition-all duration-300"
            >
              <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-secondary/15 text-secondary group-hover:bg-secondary group-hover:text-white transition-colors">
                <Icon className="w-5 h-5" />
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold text-white">{m.title}</h3>
              <p className="mt-2.5 text-sm text-white/65 leading-relaxed">{m.text}</p>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);
